// extracted by mini-css-extract-plugin
module.exports = {"mtype":"styles_mtype__1vIA3"};